export const norm = (s: string): string =>
  (s ?? '')
    .toString()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();

export const includesNorm = (haystack: string, needle: string): boolean =>
  norm(haystack).includes(norm(needle));
